export default __webpack_public_path__ + "static/media/ic_eye_login.a61bbd8d.svg";